module.exports = __webpack_public_path__ + "img/electric-energy-acumulators.bb1736ff.png";